import { Flex } from '@summer/react-kit';
import { Button, Collapse, Input, notification } from 'antd';
import { ArgsProps } from 'antd/lib/notification';
import Axios from 'axios';
import React, { FC, useRef } from 'react';
import styled from 'styled-components';

const StyledCollapse = styled(Collapse)`
  margin-top: 0.5rem;
`;

const StyledButton = styled(Button)`
  margin-left: 0.5rem;
`;

const Description: FC<{ content: string | Element; err: any }> = ({
  content,
  err,
}) => {
  const ref = useRef<Input>(null);

  const onCopy = () => {
    if (ref.current) {
      ref.current.select();
      document.execCommand('copy');
    }
  };

  return (
    <>
      {content}
      <StyledCollapse>
        <Collapse.Panel header="ErrorDetails" key="err">
          <Flex alignCenter>
            <Input value={JSON.stringify(err)} ref={ref} />
            <StyledButton onClick={onCopy}>Copy error</StyledButton>
          </Flex>
        </Collapse.Panel>
      </StyledCollapse>
    </>
  );
};

export const showError = (
  message: string | Element,
  description: string | Element,
  args?: ArgsProps
) => (err: any) => {
  return Axios.isCancel(err)
    ? null
    : notification.error({
        message,
        description: <Description content={description} err={err} />,
        duration: 0,
        ...args,
      });
};
